import React from "react"

import { Link } from "gatsby"

import { Trans } from "gatsby-plugin-react-i18next"

import TwoColumnHeroWithImageRight, {
  CONTAINMENT_MODE,
} from "../_base/TwoColumnHeroWithImageRight"

import WPImage, { DISPLAY_MODE } from "../_base/WPImage"

import Spinner from "../_base/Spinner"

import moment from "moment"

import * as rankingStyles from "../../styles/world_championships/Rankings.module.css"
import "bootstrap-icons/font/bootstrap-icons.css"

import { AirtableApi } from "../../helpers/AirtableApi"

const REFERENCE_YEAR = 2025
const SHORT_FORMAT_RECORDS = 10
const SHORT_FORMAT_PER_COLUMN = false
const SHOW_BACKGROUND_IMAGE = false

const Rankings = props => {
  const { content } = props

  const [data, setData] = React.useState(null)
  const [error, setError] = React.useState(false)

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await AirtableApi.readRecords(
          process.env.GATSBY_AIRTABLE_API_TOKEN,
          `appoE3nlX6zL5jsX4`,
          `Rankings`,
          `score`,
          `desc`,
        )

        const yearlyData = {
          [REFERENCE_YEAR - 1]: [],
          [REFERENCE_YEAR]: [],
        }

        res.records.forEach(record => {
          const year = moment(record.when).year()
          if (year < REFERENCE_YEAR - 1 || year > REFERENCE_YEAR) return

          yearlyData[year].push(record) // 2023 or 2024
        })

        setError(false)
        setData(yearlyData)
      } catch (error) {
        console.error(error)

        setError(true)
        setData([])
      }
    }
    if (!data) fetchData()
  }, [data])

  const shortFormat = props.className.split(` `).includes(`icw-short-format`)

  return (
    <div
      className={`container-fluid p-0 ${props.className} ${rankingStyles.wrapper}`}
    >
      <div className={`row g-0 ${rankingStyles.heading}`}>
        <div className={`col-12 ${rankingStyles.heading}`}>
          {/* <h4>2024</h4> */}
          <h2>Rankings</h2>
          <WPImage
            holder={content}
            selector={`header-image`}
            mode={DISPLAY_MODE.normal}
            className={`d-none d-lg-flex ${rankingStyles.headerImage}`}
          />
        </div>
      </div>
      {!data && (
        <div className={`row g-0`}>
          <div className={`col-12`}>
            <Spinner message={`Loading rankings, stay with us`} />
          </div>
        </div>
      )}
      {error && (
        <div className={`row g-0`}>
          <div className={`col-12 ${rankingStyles.error}`}>
            <h5>We couldn't load the rankings now... please try later...</h5>
          </div>
        </div>
      )}
      <div className="row g-0">
        <div className={`col-12 ${rankingStyles.board}`}>
          <TwoColumnHeroWithImageRight
            contentClass={
              shortFormat && SHOW_BACKGROUND_IMAGE
                ? rankingStyles.contentShort
                : rankingStyles.content
            }
            imageHolder={content}
            imageSelector={`background-image`}
            imageClass={
              shortFormat && SHOW_BACKGROUND_IMAGE
                ? rankingStyles.backgroundImage
                : rankingStyles.backgroundImageHidden
            }
            className={`${props.className} ranking-board-wrapper`}
            mode={CONTAINMENT_MODE.background}
          >
            {data && (
              <>
                {/* <div className={`row g-0`}>
                  <div
                    className={`col-12 ${rankingStyles.moreRankingsWrapper}`}
                  >
                    {shortFormat && !SHORT_FORMAT_PER_COLUMN && (
                      <div className={`row g-0 ${rankingStyles.moreRankings}`}>
                        <div className={`col-12`}>
                          <Link
                            className={`${rankingStyles.moreRankingsLink}`}
                            to={`/2024-tm1-world-championship-rankings`}
                          >
                            <Trans>More Rankings</Trans>
                          </Link>
                        </div>
                      </div>
                    )}
                  </div>
                </div> */}

                <div className={`row g-0`}>
                  <div
                    className={`col-12 col-lg-6 ${rankingStyles.records} ${
                      SHORT_FORMAT_PER_COLUMN || true
                        ? rankingStyles.recordsWithTopPadding
                        : ``
                    }`}
                  >
                    <div className={`${rankingStyles.recordsTable}`}>
                      <div className={`row g-0 ${rankingStyles.titleRow}`}>
                        <div className={`col-12 ${rankingStyles.title}`}>
                          Latest TM1 World Championship Ranking
                        </div>
                      </div>

                      <div className={`row g-0 ${rankingStyles.headerRow}`}>
                        <div className={`col-1 ${rankingStyles.header}`}>
                          Rank
                        </div>
                        <div className={`col-4 ${rankingStyles.header}`}>
                          Name
                        </div>
                        <div className={`col-2 ${rankingStyles.header}`}>
                          {/* Past Winner */}
                        </div>
                        <div className={`col-4 ${rankingStyles.header}`}>
                          Country
                        </div>
                        <div className={`col-1 ${rankingStyles.header}`}>
                          Score
                        </div>
                      </div>

                      {data[REFERENCE_YEAR].slice(
                        0,
                        shortFormat
                          ? SHORT_FORMAT_RECORDS
                          : data[REFERENCE_YEAR].length,
                      ).map((record, index) => (
                        <div
                          key={index}
                          className={`row g-0 ${rankingStyles.row}`}
                        >
                          <div className={`col-1 ${rankingStyles.rank}`}>
                            #{index + 1}
                          </div>
                          <div className={`col-4 ${rankingStyles.name}`}>
                            {record.name}
                          </div>
                          <div className={`col-2 ${rankingStyles.winner}`}>
                            {record.winner > 0 &&
                              Array(record.winner)
                                .fill()
                                .map((v, i) => (
                                  <i
                                    key={i}
                                    className={`bi bi-trophy-fill ${rankingStyles.award}`}
                                  ></i>
                                ))}
                          </div>
                          <div className={`col-4 ${rankingStyles.country}`}>
                            {record.country}
                          </div>
                          <div className={`col-1 ${rankingStyles.score}`}>
                            {record.score}
                          </div>
                        </div>
                      ))}
                      {shortFormat &&
                        SHORT_FORMAT_PER_COLUMN &&
                        data[REFERENCE_YEAR].length > SHORT_FORMAT_RECORDS && (
                          <div
                            className={`row g-0 ${rankingStyles.moreRankings}`}
                          >
                            <div className={`col-12`}>
                              <Link
                                className={`${rankingStyles.moreRankingsLink}`}
                                to={`/2024-tm1-world-championship-rankings`}
                              >
                                <Trans>More Rankings</Trans>
                              </Link>
                            </div>
                          </div>
                        )}
                    </div>
                  </div>

                  <div
                    className={`col-12 col-lg-6 ${rankingStyles.records} ${
                      SHORT_FORMAT_PER_COLUMN || true
                        ? rankingStyles.recordsWithTopPadding
                        : ``
                    }`}
                  >
                    <div className={`${rankingStyles.recordsTable}`}>
                      <div className={`row g-0 ${rankingStyles.titleRow}`}>
                        <div className={`col-12 ${rankingStyles.title}`}>
                          TM1 World Championship Ranking ‘{(REFERENCE_YEAR - 1).toString().slice(-2)}
                        </div>
                      </div>

                      <div className={`row g-0 ${rankingStyles.headerRow}`}>
                        <div className={`col-1 ${rankingStyles.header}`}>
                          Rank
                        </div>
                        <div className={`col-4 ${rankingStyles.header}`}>
                          Name
                        </div>
                        <div className={`col-3 ${rankingStyles.header}`}>
                          {/* Past Winner */}
                        </div>
                        <div className={`col-4 ${rankingStyles.header}`}>
                          Country
                        </div>
                        {/* <div className={`col-1 ${rankingStyles.header}`}>
                          Score
                        </div> */}
                      </div>

                      {data[REFERENCE_YEAR - 1]
                        .slice(
                          0,
                          shortFormat
                            ? SHORT_FORMAT_RECORDS
                            : data[REFERENCE_YEAR - 1].length,
                        )
                        .map((record, index) => (
                          <div
                            key={index}
                            className={`row g-0 ${rankingStyles.row}`}
                          >
                            <div className={`col-1 ${rankingStyles.rank}`}>
                              #{index + 1}
                            </div>
                            <div className={`col-4 ${rankingStyles.name}`}>
                              {record.name}
                            </div>
                            <div className={`col-3 ${rankingStyles.winner}`}>
                              {record.winner > 0 &&
                                Array(record.winner)
                                  .fill()
                                  .map((v, i) => (
                                    <i
                                      key={i}
                                      className={`bi bi-trophy-fill ${rankingStyles.award}`}
                                    ></i>
                                  ))}
                            </div>
                            <div className={`col-4 ${rankingStyles.country}`}>
                              {record.country}
                            </div>
                            {/* <div className={`col-1 ${rankingStyles.score}`}>
                              {record.score}
                            </div> */}
                          </div>
                        ))}
                      {shortFormat &&
                        SHORT_FORMAT_PER_COLUMN &&
                        data[REFERENCE_YEAR - 1].length >
                          SHORT_FORMAT_RECORDS && (
                          <div
                            className={`row g-0 ${rankingStyles.moreRankings}`}
                          >
                            <div className={`col-12`}>
                              <Link
                                className={`${rankingStyles.moreRankingsLink}`}
                                to={`/2024-tm1-world-championship-rankings`}
                              >
                                <Trans>More Rankings</Trans>
                              </Link>
                            </div>
                          </div>
                        )}
                    </div>
                  </div>
                </div>

                <div className={`row g-0`}>
                  <div
                    className={`col-12 ${rankingStyles.moreRankingsWrapperBottom}`}
                  >
                    {shortFormat && !SHORT_FORMAT_PER_COLUMN && (
                      <div className={`row g-0 ${rankingStyles.moreRankings}`}>
                        <div className={`col-12`}>
                          <Link
                            className={`${rankingStyles.moreRankingsLink}`}
                            to={`/2024-tm1-world-championship-rankings`}
                          >
                            <Trans>More Rankings</Trans>
                          </Link>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </>
            )}
          </TwoColumnHeroWithImageRight>
        </div>
      </div>
    </div>
  )
}

export default Rankings
